import { useTranslation } from 'react-i18next';
import { localizedPriceFromMinorUnit } from 'apps/commerce/common/checkout/util';

export default function useTranslatedPrice() {
  const { t } = useTranslation();

  const getTranslatedPrice = (price) => {
    let displayedPrice = null;
    let setupFee = null;
    let trialPeriod = null;

    if (price.priceType === 'recurring') {
      displayedPrice = getRecurringDisplayedPrice(price, t);
      setupFee = getSetupFee(price, t);
      trialPeriod = getTrialPeriod(price, t);
    } else {
      displayedPrice = t('pricing_options.one_time', {
        price: localizedPriceFromMinorUnit(price.currency, price.amount, price.exponent),
      });
    }

    return { displayedPrice, setupFee, trialPeriod };
  };

  return { getTranslatedPrice };
}

function getRecurringDisplayedPrice(price, t) {
  const { subscriptionPlanAttributes } = price;

  const displayedPrice = localizedPriceFromMinorUnit(
    price.currency,
    subscriptionPlanAttributes.paymentAmount,
    price.exponent,
  );

  if (
    subscriptionPlanAttributes.numberOfPayments &&
    subscriptionPlanAttributes.numberOfPayments > 0
  ) {
    return t('pricing_options.multipay', {
      price: displayedPrice,
      interval: subscriptionPlanAttributes.interval,
      numberOfPayments: subscriptionPlanAttributes.numberOfPayments,
    });
  }

  return t('pricing_options.subscription', {
    price: displayedPrice,
    interval: subscriptionPlanAttributes.interval,
  });
}

function getSetupFee(price, t) {
  const { subscriptionPlanAttributes } = price;

  if (!subscriptionPlanAttributes.setupFee || subscriptionPlanAttributes.setupFee <= 0) return null;

  return t('pricing_options.setup_fee', {
    setupFee: localizedPriceFromMinorUnit(
      price.currency,
      subscriptionPlanAttributes.setupFee,
      price.exponent,
    ),
  });
}

function getTrialPeriod(option, t) {
  const { subscriptionPlanAttributes } = option;

  if (
    !subscriptionPlanAttributes.trialPeriodDays ||
    subscriptionPlanAttributes.trialPeriodDays <= 0
  )
    return null;

  return t('pricing_options.trial_period', {
    trialPeriod: subscriptionPlanAttributes.trialPeriodDays,
  });
}
